<!-- breadcrumb -->
<!-- <sv-breadcrumb></sv-breadcrumb> -->
<br />

<!-- detail loader -->
<div *ngIf="loading">
  <sv-product-detail-loader></sv-product-detail-loader>
</div>

<div class="c-productCard" *ngIf="(!data || !data.C000) && !loading">
  <h2>
    <span *ngIf="generalService.translationMode === true"> (P001) </span>
    {{ "PRODUCT.P001.value" | translate }}
  </h2>
</div>

<!-- product-detail New Design -->
<div class="c-productCard" tabindex="0" *ngIf="data && data.C000 && !loading">
  <div class="c-productCard__imageContainer">
    <div class="c-productCard__imageWrap">
      <img
        *ngIf="data && data.F000"
        [src]="generalService.resizeImage(data.F000, '-l')"
        class="c-productCard__image"
        [alt]="data.F001"
      />
      <span
        *ngIf="data.F027 && data.F027 === true"
        class="c-productCard__tag--new"
        [hidden]
        >Uutuus</span
      >
    </div>
    <div class="c-productCard__notes">
      <img
        *ngIf="data.F025 && data.F025 === true"
        class="c-productCard__noteIcon"
        src="assets/images/product/icons/organic-fi.svg"
        alt="Organic"
      />
      <img
        *ngIf="data.F028 && data.F028 === true"
        class="c-productCard__noteIcon"
        src="assets/images/product/icons/local-fi.svg"
        alt="Local"
      />
    </div>
    <span *ngIf="!itemLoaded">
      <ng-container *ngIf="focusOnProduct()"></ng-container>
    </span>
  </div>

  <div class="c-productCard__body">
    <div class="c-productCard__main">
      <div class="c-productCard__meta">
        <div class="c-price c-productCard__price">
          <span *ngIf="generalService.debugMode"> [ F018 ] </span>
          <span class="c-price-base c-productCard__price-base">{{
            basePrice || "0"
          }}</span>
          <span class="c-price-sub c-productCard__price-sub">{{
            subPrice || "00"
          }}</span>
          <div
            class="c-price-discount c-productCard__price-discount"
            *ngIf="data.F007"
          >
            <span *ngIf="generalService.debugMode"> [ F007 ] </span>
            <span class="visuallyhidden">Discount: </span
            >{{ data.F007 | number : "1.2-3" | shopCurrencyDigits }}
          </div>
          <div class="c-price-reference c-productCard__price-refrence">
            <span *ngIf="generalService.debugMode"> [ F033 ] </span>
            <span class="visuallyhidden">Reference:</span>
            <span [innerHTML]="data.F033"></span>
          </div>
        </div>
        <div class="c-productCard__meta-details">
          <!-- <div class="c-productCard__quantity">
            <span *ngIf="generalService.debugMode"> [ F005 ] </span>
            <span class="visuallyhidden">Quantity:</span>
            <span *ngIf="data.F005" [innerHTML]="data.F005"></span>
          </div> -->
          <!-- <div class="c-productCard__referencePrice hidden">
            <span class="visuallyhidden">Reference title:</span>
            <span class="js-value">3,8 €/kg</span>
          </div> -->
        </div>
        <sv-buy-btn
          [data]="data"
          [parent]="'product-detail'"
          class="c-productCard__addToCart c-addToCart"
        ></sv-buy-btn>
      </div>

      <div class="c-productCard__header">
        <h1 class="c-productCard_title">
          <span *ngIf="generalService.debugMode"> [ F001 ] </span>
          {{ data.F001 }}
        </h1>
        <h2 class="c-productCard_titleDescription">
          <span *ngIf="generalService.debugMode"> [ F002 ] </span>
          {{ data.F002 }}
        </h2>
        <div class="c-productCard__quantity">
          <span class="visuallyhidden">Quantity:</span>
          <span *ngIf="generalService.debugMode"> [F032] </span>
          <span *ngIf="data.F032" [innerHTML]="data.F032"></span>
        </div>
      </div>
      <div class="c-productCard__details">
        <div class="c-productCard__metaIcons">
          <span
            class="c-productCard__tag--sale"
            *ngIf="data.F026 && data.F026 === true"
            >Tarjous</span
          >

          <img
            *ngIf="data.F021 && data.F021 === true"
            class="c-productCard__metaIcon"
            src="assets/images/product/icons/frozen.svg"
            alt="Frozen"
          />

          <img
            *ngIf="data.F022 && data.F022 === true"
            class="c-productCard__metaIcon"
            src="assets/images/product/icons/vegan.svg"
            alt="Vegan"
          />

          <img
            *ngIf="data.F023 && data.F023 === true"
            class="c-productCard__metaIcon"
            src="assets/images/product/icons/gluten-free.svg"
            alt="Gluten free"
          />

          <img
            *ngIf="data.F024 && data.F024 === true"
            class="c-productCard__metaIcon"
            src="assets/images/product/icons/lactose-free.svg"
            alt="Lactose free"
          />
        </div>

        <div class="c-productCard__marketing">
          <span *ngIf="generalService.debugMode"> [ F003 ] </span>
          {{ data.F003 }}
        </div>

        <br />
        <span *ngIf="generalService.debugMode"> [ F100 ] </span>
        <div
          [innerHTML]="data.F100"
          *ngIf="data.F100"
          class="c-productCard__text"
        ></div>

        <div
          class="c-productCard__extra"
          id="productViewExtra"
          *ngIf="ingredientsBox"
        >
          <div
            class="c-productCard__text"
            [innerHTML]="data.L007 && data.L007"
          ></div>
          <button
            class="b-productCard__extra-close"
            (click)="toggleIngredients()"
          >
            <span class="is-icon icon-close"></span>
            <span class="visuallyhidden">Close</span>
          </button>
        </div>
      </div>
    </div>

    <br />
    <div class="extra-debug-info" *ngIf="generalService.debugMode">
      <b> Extra debug info : </b>
      <br />
      <small>
        <pre> {{ data | json }} </pre>
      </small>
    </div>
  </div>
</div>

<!-- suggested products grid -->
<div *ngIf="data && data.D001">
  <sv-product-grid
    [displayGroup]="data.D001"
    [detailProductId]="data.C000"
  ></sv-product-grid>
</div>

<ngx-json-ld [json]="jsonLdSchema"></ngx-json-ld>
